// extracted by mini-css-extract-plugin
export var video = "VideoAutoplay-module--video--9b4QR";
export var playPauseButton = "VideoAutoplay-module--playPauseButton--i3jSb";
export var videoElement = "VideoAutoplay-module--videoElement--2mILW";
export var show = "VideoAutoplay-module--show--2Ejh-";
export var showFadeInDown = "VideoAutoplay-module--show-fade-in-down--3aIGq";
export var showFadeInUp = "VideoAutoplay-module--show-fade-in-up--hgivy";
export var hideFadeOut = "VideoAutoplay-module--hide-fade-out--ukuqp";